import React from 'react';

/**
 * Sektions-Hintergrund unterhalb Hero — rein CSS (scharf, keine Mux/HLS-Pixelierung).
 * Voltage-Mesh + feines Grid + dezente Sternpunkte in ARKORBIT-Farben.
 */
export const T05StarsBackground: React.FC = () => (
  <div className="t05-below-hero__stars" aria-hidden>
    <div className="t05-section-bg__mesh" />
    <div className="t05-section-bg__stars" />
    <div className="t05-section-bg__grid" />
    <div className="t05-section-bg__scrim" />
  </div>
);
